import(/* webpackMode: "eager" */ "/home/u861559092/domains/persimateriais.com.br/hbuilds/source/app/global-error.tsx");
